import React, { useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const PasswordInput = ({label, name, changeData, errorMsg, value,passwordStrengthMsg}) => {
    

    const [type, setType] = useState(true)

    return (
        <>
            <div className='position-relative'>
                <span className="eye-icon" style={{bottom:"-3px"}} onClick={() => setType((prevVal => !prevVal))}>
                    {
                        type ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon  icon={faEye} onClick={() => setType(false)} />
                    }
                </span>
                <label>{label}<span className="text-danger m-0 d-inline-block"> *</span></label>
                <input type={type ? "password" : "text"} name={name} placeholder="Enter Password" value={value} onChange={(e) => changeData(name, e.target.value)}/>
            </div>
            {errorMsg && <p className="error ">{errorMsg}</p>}
            {passwordStrengthMsg && <p className="error ">{passwordStrengthMsg}</p>}

            
        </>
    )
}

export default PasswordInput